module.exports = __webpack_public_path__ + "assets/arrow-0f0b5c.svg";